import { ControlWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';

@Component({
  selector: 'app-sf-custom-widget',
  templateUrl: './custom.widget.html'
})
export class MyCustomWidgetComponent extends ControlWidget {}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/custom/custom.widget.ts